import { TextalignRight, MessageText, Link21 } from "iconsax-reactjs"
import InputFiel from "../../commons/InputFiel"

type BannerTextSectionProps = {
  title: string
  relatedContent: string
  description: string
  onTitleChange: (v: string) => void
  onRelatedContentChange: (v: string) => void
  onDescriptionChange: (v: string) => void
}

export default function BannerTextSection({ title, relatedContent, description, onTitleChange, onRelatedContentChange, onDescriptionChange }: BannerTextSectionProps) {

  return (
    <div className="max-w-full bg-white border rounded-2xl card-shadow p-4 flex flex-col gap-6">

      <div className="flex flex-col gap-2">
        <h3 className="flex items-center gap-1 text-gray-600 font-medium text-base leading-7">
          <TextalignRight size="20" />
          عنوان بنر
        </h3>
        <InputFiel 
          as="input"
          size="lg"
          value={title}
          placeholder="مثلاً جشنواره تخفیف زمستانه"
          maxLength={50}
          disabled={false}
          onChange={(e) => onTitleChange(e.target.value)}
        />
        <p className="font-semibold text-xs text-gray-400">
          حداکثر ظرفیت برای تایپ 50 کاراکتر میباشد.
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="flex items-center gap-1 text-gray-600 font-medium text-base leading-7">
          <Link21 size="20" />
          لینک محتوا
        </h3>
        <InputFiel 
          as="input"
          size="lg"
          value={relatedContent}
          placeholder="آدرس بعد از دامین وارد شود"
          maxLength={50}
          disabled={false}
          onChange={(e) => onRelatedContentChange(e.target.value)}
        />
        <p className="font-semibold text-xs text-gray-400">
          حداکثر ظرفیت برای تایپ 50 کاراکتر میباشد.
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="flex items-center gap-1 text-gray-600 font-medium text-base leading-7">
          <MessageText size="20" />
          توضیح بنر
        </h3>
        <InputFiel 
          as="textarea"
          size="lg"
          value={description}
          placeholder="توضیح کوتاه درباره محتوای بنر"
          maxLength={150}
          rows={3}
          disabled={false}
          onChange={(e) => onDescriptionChange(e.target.value)}
        />
        <p className="font-semibold text-xs text-gray-400">
          حداکثر ظرفیت برای تایپ 150 کاراکتر میباشد.
        </p>
      </div>

    </div>
  )
};